import { useEffect, useState } from "react";

const useBrowserName = () => {
    const [browserName, setBrowserName] = useState("");

    useEffect(() => {
        const detectBrowserName = () => {
            const userAgent = navigator.userAgent;

            if (userAgent.includes("Chrome") && !userAgent.includes("Edg")) {
                return "Google Chrome";
            } else if (userAgent.includes("Firefox")) {
                return "Mozilla Firefox";
            } else if (userAgent.includes("Safari") && !userAgent.includes("Chrome")) {
                return "Apple Safari";
            } else if (userAgent.includes("Edg")) {
                return "Microsoft Edge";
            } else if (userAgent.includes("Opera") || userAgent.includes("OPR")) {
                return "Opera";
            } else {
                return "Unknown Browser";
            }
        };

        setBrowserName(detectBrowserName());
    }, []);

    return browserName;
};

export default useBrowserName;
